var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAnalytics(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2851_24652",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2851_24652)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.5 20C18.0833 20 17.7293 19.854 17.438 19.562C17.146 19.2707 17 18.9167 17 18.5V5.5C17 5.08333 17.146 4.72933 17.438 4.438C17.7293 4.146 18.0833 4 18.5 4C18.9167 4 19.2707 4.146 19.562 4.438C19.854 4.72933 20 5.08333 20 5.5V18.5C20 18.9167 19.854 19.2707 19.562 19.562C19.2707 19.854 18.9167 20 18.5 20ZM6.5 20C6.3 20 6.10833 19.9623 5.925 19.887C5.74167 19.8123 5.57933 19.704 5.438 19.562C5.296 19.4207 5.18767 19.2583 5.113 19.075C5.03767 18.8917 5 18.7 5 18.5V15.5C5 15.0833 5.146 14.7293 5.438 14.438C5.72933 14.146 6.08333 14 6.5 14C6.91667 14 7.27067 14.146 7.562 14.438C7.854 14.7293 8 15.0833 8 15.5V18.5C8 18.7 7.96267 18.8917 7.888 19.075C7.81267 19.2583 7.704 19.4207 7.562 19.562C7.42067 19.704 7.25833 19.8123 7.075 19.887C6.89167 19.9623 6.7 20 6.5 20ZM12.5 20C12.0833 20 11.7293 19.854 11.438 19.562C11.146 19.2707 11 18.9167 11 18.5V10.5C11 10.0833 11.146 9.72933 11.438 9.438C11.7293 9.146 12.0833 9 12.5 9C12.9167 9 13.2707 9.146 13.562 9.438C13.854 9.72933 14 10.0833 14 10.5V18.5C14 18.9167 13.854 19.2707 13.562 19.562C13.2707 19.854 12.9167 20 12.5 20Z",
    fill: "#1F242F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalytics);
export default __webpack_public_path__ + "static/media/analytics.35ea4df8d4e404b94e95227771ea8a7b.svg";
export { ForwardRef as ReactComponent };